import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RedirectGuard } from './utils/redirect.guard'


import {
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbLayoutModule,
  NbCalendarMonthCellComponent
} from '@nebular/theme';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule, ToastContainerModule } from 'ngx-toastr';
import { AuthModule, OidcConfigService, LogLevel } from 'angular-auth-oidc-client';
import { AuthInterceptor } from './core/authencation/auth-interceptor';
import { switchMap, map } from 'rxjs/operators';
import { HttpService } from './core/services/http/http.service';
import { LoaderService } from './core/services/loadder/loadder.service';
import { getBaseUrl } from './utils/helpers';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { vi } from 'date-fns/locale';
import { registerLocaleData } from '@angular/common';
import localeVi from '@angular/common/locales/vi';

registerLocaleData(localeVi, 'vi-VN');

export function configureAuth(oidcConfigService: OidcConfigService, httpClient: HttpClient) {
  const setupAction$ = httpClient.get<any>(`${getBaseUrl()}api/Settings/GetWebAuthSettings`).pipe(
    map((customConfig) => {
      return {
        stsServer: customConfig.stsServer,
        redirectUrl: customConfig.redirectUrl,
        clientId: customConfig.clientId,
        responseType: customConfig.responseType,
        scope: customConfig.scope,
        postLogoutRedirectUri: customConfig.postLogoutRedirectUri,
        silentRenew: false,
        silentRenewUrl: customConfig.silentRenewUrl + '/silent-renew.html',
        logLevel: customConfig.logLevel
      };
    }),
    switchMap((config) => oidcConfigService.withConfig(config))
  );
  return () => setupAction$.toPromise();
}


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AuthModule.forRoot(),
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    ThemeModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDateFnsDateModule.forRoot({
      parseOptions: { locale: vi },
      formatOptions: { locale: vi },
      format: 'dd/MM/yyyy'
    }),
    NbDateFnsDateModule.forChild({
      parseOptions: { locale: vi },
      formatOptions: { locale: vi },
      format: 'dd/MM/yyyy'
    }),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    ToastrModule.forRoot({ positionClass: 'inline' }),
    ToastContainerModule,
    Ng2SmartTableModule,
    NbLayoutModule,
    ReactiveFormsModule,
    AppRoutingModule,

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    { provide: LOCALE_ID, useValue: "vi-VN" },
    OidcConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: configureAuth,
      deps: [OidcConfigService, HttpClient],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    HttpService,
    LoaderService,
    RedirectGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    // Override issue method for nebular -- https://github.com/akveo/nebular/issues/2303
    Object.defineProperty(NbCalendarMonthCellComponent.prototype, 'selected', {
      get() {
        return this.dateService.isSameMonthSafe(
          this.date,
          this.selectedValue ? this.selectedValue.end : new Date()
        );
      },
      enumerable: true,
      configurable: true
    });
  }
}
